import { ListingCardMarkerOverlay } from './ListingCardMarkerOverlay';

export class ListingTopMarketCardMarkerOverlay extends ListingCardMarkerOverlay {}
